// Minimal element helper. No framework, no virtual DOM — just less boilerplate
// than document.createElement everywhere.

type Child = Node | string;
type Attrs = Record<string, string | number | boolean | undefined>;

export function el(tag: string, attrs: Attrs = {}, children: Child | Child[] = []): HTMLElement {
  const node = document.createElement(tag);
  for (const [key, value] of Object.entries(attrs)) {
    if (value === undefined || value === false) continue;
    if (value === true) node.setAttribute(key, '');
    else node.setAttribute(key, String(value));
  }
  const list = Array.isArray(children) ? children : [children];
  for (const child of list) {
    node.append(typeof child === 'string' ? document.createTextNode(child) : child);
  }
  return node;
}
